import React from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import NavHome from "src/assets/images/navHome.svg";
import NavHomeActive from "src/assets/images/navHomeActive.svg";
import NavNotice from "src/assets/images/navNotice.svg";
import NavNoticeActive from "src/assets/images/navNoticeActive.svg";
import NavAs from "src/assets/images/navAs.svg";
import NavAsActive from "src/assets/images/navAsActive.svg";
import NavSchedule from "src/assets/images/navSchedule.svg";
import NavScheduleActive from "src/assets/images/navScheduleActive.svg";
import NavStore from "src/assets/images/navStore.svg";
import NavStoreActive from "src/assets/images/navStoreActive.svg";
import { useAppSelector } from "src/store/actions/action";

const Tabbar = () => {
  const userInfo = useAppSelector((state) => state.userReduce.userInfo);
  return (
    <TabbarWrap>
      <ul>
        <li>
          <NavLink to="/home" className={({ isActive }) => "nav-home" + (isActive ? " active" : "")}>
            홈
          </NavLink>
        </li>
        <li>
          <NavLink to="/notice-list" className={({ isActive }) => "nav-notice" + (isActive ? " active" : "")}>
            공지
          </NavLink>
        </li>
        <li>
          <NavLink to="/as-list" className={({ isActive }) => "nav-as" + (isActive ? " active" : "")}>
            A/S
          </NavLink>
        </li>
        <li>
          <NavLink to="/schedule" className={({ isActive }) => "nav-schedule" + (isActive ? " active" : "")}>
            일정
          </NavLink>
        </li>
        {userInfo.user_type === "E" ? (
          <li>
            <NavLink to="/manage-list" className={({ isActive }) => "nav-store" + (isActive ? " active" : "")}>
              매장/업체
            </NavLink>
          </li>
        ) : (
          ""
        )}
      </ul>
    </TabbarWrap>
  );
};

const TabbarWrap = styled.nav`
  z-index: 1000;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  -webkit-box-shadow: 0 0 5px ${({ theme }) => theme.color.linePrimary};
  box-shadow: 0 0 5px ${({ theme }) => theme.color.linePrimary};
  ul {
    width: 100%;
    padding: 5px 0 3px;
    ${({ theme }) => theme.flexBox.flexMixin("row", "space-around")};
    li {
      flex-grow: 1;
      text-align: center;
      > a {
        display: inline-block;
        width: 100%;
        min-width: 40px;
        padding-top: 32px;
        color: ${({ theme }) => theme.color.secondary};
        font-family: "Roboto";
        font-weight: 400;
        font-size: 12px;
        text-align: center;
        background-repeat: no-repeat;
        background-position: center top;
        transition: all 0.3s;
        &.active {
          color: ${({ theme }) => theme.color.main};
        }
        &.nav-home {
          background-image: url(${NavHome});
          &.active {
            background-image: url(${NavHomeActive});
          }
        }
        &.nav-notice {
          background-image: url(${NavNotice});
          &.active {
            background-image: url(${NavNoticeActive});
          }
        }
        &.nav-as {
          background-image: url(${NavAs});
          &.active {
            background-image: url(${NavAsActive});
          }
        }
        &.nav-schedule {
          background-image: url(${NavSchedule});
          &.active {
            background-image: url(${NavScheduleActive});
          }
        }
        &.nav-store {
          background-image: url(${NavStore});
          &.active {
            background-image: url(${NavStoreActive});
          }
        }
      }
    }
  }
`;

export default Tabbar;
